import {
  SET_CARD_FRAME_SEARCHING,
  SET_ABNORMAL_JOB_LIST,
  SET_CARD_FRAME_SORT,
  SET_CARD_FRAME_QUERY,
  SET_CARD_FRAME_LIST_PAGE_SIZE,
  SET_FRAME_PAGE_NUM,
  SET_LIST_PAGE_TOTAL,
  SET_STATISTICS_FRAME_LIST,
  SET_STATISTICS_FRAME_SORT,
  SET_STATISTICS_FRAME_QUERY,
  SET_STATISTICS_FRAME_LIST_PAGE_SIZE,
  SET_STATISTICS_FRAME_PAGE_NUM,
  SET_STATISTICS_LIST_PAGE_TOTAL,
  SET_STUCK_FRAME_STATISTICS_LIST,
  SET_STUCK_FRAME_STATISTICS_QUERY,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageSize: 50,
  pageNum: 1,
  startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
  endDate: new Date().setHours(23, 59, 59, 999),
  isAbnormal: 1,
  salesmenId: '',
  pcId: '',
  tdId: '',
  abnormalTypes: [],
  reportType: '',
  nodeName: '',
  platform: '',
})

const initStatisticsQuery = () => ({
  pageSize: 50,
  pageNum: 1,
  startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
  endDate: new Date().setHours(23, 59, 59, 999),
  nodeName: '',
})

const initStuckFrameStatisticsQuery = () => ({
  startDate: new Date().getTime() - 3600 * 1000 * 24 * 15,
  endDate: new Date().setHours(23, 59, 59, 999) - 24 * 60 * 60 * 1000,
  type: 0, // 0按日，1按月
  platformList: [],
})

const state = {
  searching: false,
  abnormalJobList: [],
  sort: {},
  query: {
    pageSize: 50,
    pageNum: 1,
    startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
    endDate: new Date().setHours(23, 59, 59, 999),
    isAbnormal: 1,
    salesmenId: '',
    pcId: '',
    tdId: '',
    abnormalTypes: [],
    reportType: '',
    nodeName: '',
  },
  pageTotal: 0,
  initQuery: initQuery(),
  statisticsCardFrame: {
    list: [],
    pageTotal: 0,
    initQuery: initStatisticsQuery(),
    query: initStatisticsQuery(),
    sort: {},
  },
  stuckFrameStatistics: {
    list: {
      machine: [],
      abnormalReasons: [],
    },
    pageTotal: 0,
    initQuery: initStuckFrameStatisticsQuery(),
    query: initStuckFrameStatisticsQuery(),
    sort: {},
  },
}

const mutations = {
  [SET_CARD_FRAME_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_ABNORMAL_JOB_LIST] (state, payload) {
    state.abnormalJobList = payload
  },
  [SET_CARD_FRAME_SORT] (state, payload) {
    state.sort = payload
  },
  [SET_CARD_FRAME_QUERY] (state, payload) {
    state.query = {
      ...state.query,
      ...payload,
    }
  },
  [SET_CARD_FRAME_LIST_PAGE_SIZE] (state, payload) {
    state.query.pageSize = payload
  },
  [SET_FRAME_PAGE_NUM] (state, payload) {
    state.query.pageNum = payload
  },
  [SET_LIST_PAGE_TOTAL] (state, payload) {
    state.pageTotal = payload
  },

  [SET_STATISTICS_FRAME_LIST] (state, payload) {
    state.statisticsCardFrame.list = payload
  },
  [SET_STATISTICS_FRAME_SORT] (state, payload) {
    state.statisticsCardFrame.sort = payload
  },
  [SET_STATISTICS_FRAME_QUERY] (state, payload) {
    state.statisticsCardFrame.query = {
      ...state.statisticsCardFrame.query,
      ...payload,
    }
  },
  [SET_STATISTICS_FRAME_LIST_PAGE_SIZE] (state, payload) {
    state.statisticsCardFrame.query.pageSize = payload
  },
  [SET_STATISTICS_FRAME_PAGE_NUM] (state, payload) {
    state.statisticsCardFrame.query.pageNum = payload
  },
  [SET_STATISTICS_LIST_PAGE_TOTAL] (state, payload) {
    state.statisticsCardFrame.pageTotal = payload
  },

  // 卡帧统计
  [SET_STUCK_FRAME_STATISTICS_LIST] (state, payload) {
    state.stuckFrameStatistics.list = payload
  },
  [SET_STUCK_FRAME_STATISTICS_QUERY] (state, payload) {
    state.stuckFrameStatistics.query = {
      ...state.stuckFrameStatistics.query,
      ...payload,
    }
  },
}

const actions = {
  async getCurrentAbnormalJobs ({commit, state}, payload) {
    try {
      commit(SET_CARD_FRAME_SEARCHING, true)
      let query = {}
      _.forIn(state.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      let params = {
        ...query,
        ...state.sort,
      }
      let {data: {items, total}} = await api.monitorApi.getCurrentAbnormalJobs(params)
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_ABNORMAL_JOB_LIST, items)
      commit(SET_LIST_PAGE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_LIST_PAGE_TOTAL, 0)
      commit(SET_ABNORMAL_JOB_LIST, [])
    }
  },
  async initCurrentAbnormalJobs ({dispatch}) {
    await dispatch('setCardFrameQuery', state.initQuery)
    await dispatch('getCurrentAbnormalJobs')
  },
  setCardFrameQuery ({commit}, payload) {
    commit(SET_CARD_FRAME_QUERY, payload)
  },
  async restartAbnormalJob ({commit, state, dispatch}, payload) {
    commit(SET_CARD_FRAME_SEARCHING, true)
    let data = await api.monitorApi.restartAbnormalJob(payload)
    dispatch('getCurrentAbnormalJobs', {})
    return data
  },
  async abortAbnormalJob ({commit, state, dispatch}, payload) {
    commit(SET_CARD_FRAME_SEARCHING, true)
    let data = await api.monitorApi.abortAbnormalJob(payload)
    dispatch('getCurrentAbnormalJobs', {})
    return data
  },
  async cancelCardFrame ({commit, state, dispatch}, payload) {
    commit(SET_CARD_FRAME_SEARCHING, true)
    const frameDbIds = payload.operateTasks.map(item => item.frameId)
    const taskIds = payload.operateTasks.map(item => item.taskId)
    const jobNames = payload.operateTasks.map(item => item.jobName)
    let data = await api.monitorApi.cancelCardFrame({frameDbIds, taskIds, jobNames})
    dispatch('getCurrentAbnormalJobs', {})
    return data
  },
  async removeAbnormalJobCache ({commit, state}, payload) {
    try {
      commit(SET_CARD_FRAME_SEARCHING, true)
      let {data} = await api.monitorApi.removeAbnormalJobCache(payload)
      commit(SET_CARD_FRAME_SEARCHING, false)
      return data
    } catch (error) {
      commit(SET_CARD_FRAME_SEARCHING, false)
    }
  },
  changeCardFrameSort ({commit, dispatch}, payload) {
    commit(SET_CARD_FRAME_SORT, payload)
    dispatch('setPageNum', 1)
  },
  // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_CARD_FRAME_LIST_PAGE_SIZE, payload.pageSize)
    dispatch('getCurrentAbnormalJobs')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_FRAME_PAGE_NUM, payload)
    dispatch('getCurrentAbnormalJobs')
  },
  // 卡帧设置
  async abnormalJobsSetting ({commit, state, dispatch}, payload) {
    let data = await api.monitorApi.abnormalJobsSetting(payload)
    dispatch('getCurrentAbnormalJobs')
    return data
  },
  // 卡帧设置回显
  async getAbnormalJobsSetting ({commit, state, dispatch}, payload) {
    let data = await api.monitorApi.getAbnormalJobsSetting(payload)
    return data
  },
  // 取消、恢复卡帧
  async operateAbnormalJobs ({commit, state, dispatch}, payload) {
    let data = await api.monitorApi.operateAbnormalJobs(payload)
    dispatch('getCurrentAbnormalJobs')
    return data
  },
  // 获取卡帧操作记录
  async getAbnormalJobsOperateRecords ({commit, state, dispatch}, payload) {
    let data = await api.monitorApi.getAbnormalJobsOperateRecords(payload)
    return data
  },

  async getStatisticsCardFrame ({commit, state}, payload) {
    try {
      commit(SET_CARD_FRAME_SEARCHING, true)
      let query = {}
      _.forIn(state.statisticsCardFrame.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      let params = {
        ...query,
        ...state.statisticsCardFrame.sort,
      }
      let {data: {items, total}} = await api.monitorApi.getStatisticsCardFrame(params)
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_STATISTICS_FRAME_LIST, items)
      commit(SET_STATISTICS_LIST_PAGE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_STATISTICS_LIST_PAGE_TOTAL, 0)
      commit(SET_STATISTICS_FRAME_LIST, [])
    }
  },
  async initStatisticsCardFrame ({dispatch}) {
    await dispatch('setStatisticsCardFrameQuery', state.statisticsCardFrame.initQuery)
    await dispatch('getStatisticsCardFrame')
  },
  setStatisticsCardFrameQuery ({commit}, payload) {
    commit(SET_STATISTICS_FRAME_QUERY, payload)
  },
  changeStatisticsCardFrameSort ({commit, dispatch}, payload) {
    commit(SET_STATISTICS_FRAME_SORT, payload)
    dispatch('setStatisticsPageNum', 1)
  },
  // 改变每页显示条数
  changeStatisticsPageSize ({commit, dispatch}, payload) {
    commit(SET_STATISTICS_FRAME_LIST_PAGE_SIZE, payload.pageSize)
    dispatch('getStatisticsCardFrame')
  },
  setStatisticsPageNum ({commit, dispatch}, payload) {
    commit(SET_STATISTICS_FRAME_PAGE_NUM, payload)
    dispatch('getStatisticsCardFrame')
  },

  // 卡帧统计
  async getStuckFrameStatistics ({commit, state}, payload) {
    const emptyData = {
      machine: [],
      abnormalReasons: [],
    }
    try {
      commit(SET_CARD_FRAME_SEARCHING, true)
      let query = {}
      _.forIn(state.stuckFrameStatistics.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      const params = {
        ...query,
        ...state.stuckFrameStatistics.sort,
      }
      const { data } = await api.monitorApi.getStuckFrameStatistics(params)
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_STUCK_FRAME_STATISTICS_LIST, data || emptyData)
      return data
    } catch (error) {
      commit(SET_CARD_FRAME_SEARCHING, false)
      commit(SET_STUCK_FRAME_STATISTICS_LIST, emptyData)
    }
  },
  async initStuckFrameStatistics ({dispatch}) {
    await dispatch('setStatisticsCardFrameQuery', state.statisticsCardFrame.initQuery)
    await dispatch('getStuckFrameStatistics')
  },
  setStuckFrameStatisticsQuery ({commit}, payload) {
    commit(SET_STUCK_FRAME_STATISTICS_QUERY, payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
